import { render, staticRenderFns } from "./lb-column.vue?vue&type=template&id=7b381518"
import script from "./lb-column.vue?vue&type=script&lang=js"
export * from "./lb-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b381518')) {
      api.createRecord('7b381518', component.options)
    } else {
      api.reload('7b381518', component.options)
    }
    module.hot.accept("./lb-column.vue?vue&type=template&id=7b381518", function () {
      api.rerender('7b381518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/saleOrder/components/lb-table/lb-column.vue"
export default component.exports